export default __webpack_public_path__ + "static/media/body-img-sportscar.15010e75.png";